<template>
  <div id="qrs">
    <div class="centered-div">
        <a href="https://play.google.com/store/apps/details?id=com.ltex.mr.mobile"><img src="/qr/android.png" alt="Download para Android"></a>
        <a href="https://apps.apple.com/br/app/meus-rituais/id6618112659"><img src="/qr/ios.png" alt="Download para iPhone"></a>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.redirectBasedOnDevice();
  },
  methods: {
    redirectBasedOnDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        // Redireciona para a Google Play Store
        window.location.href = "https://play.google.com/store/apps/details?id=com.ltex.mr.mobile";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // Redireciona para a Apple App Store
        window.location.href = "https://apps.apple.com/br/app/meus-rituais/id6618112659";
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#qrs {
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.centered-div {
  display: flex;
  gap: 100px;
}

.centered-div img {
  width: 300px;
  height: auto;
}

</style>
